export default __webpack_public_path__ + "static/media/eye.34eae9b4.svg";